import React, { createContext, useContext, useState } from "react";

const SubMenuContext = createContext();

export const useSubMenu = () => {
    const context = useContext(SubMenuContext)

    if (!context) {
        console.log(context)
        throw new Error("useSubMenu must be used within a SubMenuProvider");
    } else {
        return context;
    }
}


export const SubMenuProvider = ({ children }) => {
    const [showSubMenuProduct, setShowSubMenuProduct] = useState(false);
    const [showSubMenuProductMob, setShowSubMenuProductMob] = useState(false);


    const [showSubMenuSolutions, setShowSubMenuSolutions] = useState(false);
    const [showSubMenuSolutionsMob, setShowSubMenuSolutionsMob] = useState(false);

    const [showSubMenuSuporte, setShowSubMenuSuporte] = useState(false);
    const [showSubMenuSuporteMob, setShowSubMenuSuporteMob] = useState(false);

    const [showSubMenuExemplo, setShowSubMenuExemplo] = useState(false);
    const [showSubMenuExemploMob, setShowSubMenuExemploMob] = useState(false);


    const closeOnScroll = () => {
        setShowSubMenuSolutions(false)
        setShowSubMenuProduct(false)
        setShowSubMenuExemplo(false)
        setShowSubMenuSuporte(false)
        setShowSubMenuSolutionsMob(false)
        setShowSubMenuSuporteMob(false)
        setShowSubMenuProductMob(false)
    }



    const handleShowSubMenuProduct = () => {

        if(showSubMenuSolutions || showSubMenuSuporte || showSubMenuExemplo){
            setShowSubMenuSolutions(false);
            setShowSubMenuSuporte(false);
            setShowSubMenuExemplo(false);
        }
        setShowSubMenuProduct(!showSubMenuProduct);
    }

    const handleShowSubMenuProductMob = () => {

        if(showSubMenuSolutionsMob || showSubMenuSuporteMob || showSubMenuExemploMob){
            setShowSubMenuSolutionsMob(false);
            setShowSubMenuSuporteMob(false);
            setShowSubMenuExemploMob(false);
        }
        setShowSubMenuProductMob(!showSubMenuProductMob);
    }


    const handleShowSubMenuSolutions = () => {

        if(showSubMenuProduct === true) {
            setShowSubMenuProduct(false);
        }
        if(showSubMenuSuporte === true) {
            setShowSubMenuSuporte(false);
        }
        if(showSubMenuExemplo === true) {
            setShowSubMenuExemplo(false);
        }
        setShowSubMenuSolutions(!showSubMenuSolutions);
    }

    const handleShowSubMenuSolutionsMob = () => {

        if(showSubMenuProductMob === true) {
            setShowSubMenuProductMob(false);
        }
        if(showSubMenuSuporteMob === true) {
            setShowSubMenuSuporteMob(false);
        }
        if(showSubMenuExemploMob === true) {
            setShowSubMenuExemploMob(false);
        }
        setShowSubMenuSolutionsMob(!showSubMenuSolutionsMob);
    }

    const handleShowSubMenuSuporte = () => {
        if (showSubMenuProduct === true) {
            setShowSubMenuProduct(false);
        }
        if (showSubMenuSolutions === true) {
            setShowSubMenuSolutions(false);
        }
        if(showSubMenuExemplo === true) {
            setShowSubMenuExemplo(false);
        }
        setShowSubMenuSuporte(!showSubMenuSuporte);
    }

    const handleShowSubMenuSuporteMob = () => {
        if (showSubMenuProductMob === true) {
            setShowSubMenuProductMob(false);
        }
        if (showSubMenuSolutionsMob === true) {
            setShowSubMenuSolutionsMob(false);
        }
        if(showSubMenuExemploMob === true) {
            setShowSubMenuExemploMob(false);
        }
        setShowSubMenuSuporteMob(!showSubMenuSuporte);
    }

    const handleShowSubMenuExemplo = () => {
        if( showSubMenuProduct === true || showSubMenuSolutions === true || showSubMenuSuporte === true){
            setShowSubMenuProduct(false)
            setShowSubMenuSolutions(false)
            setShowSubMenuSuporte(false)
        }
        setShowSubMenuExemplo(!showSubMenuExemplo);
   
    }

    const handleShowSubMenuExemploMob = () => {
        if( showSubMenuProductMob === true || showSubMenuSolutionsMob === true || showSubMenuSuporteMob === true){
            setShowSubMenuProductMob(false)
            setShowSubMenuSolutionsMob(false)
            setShowSubMenuSuporteMob(false)
        }
        setShowSubMenuExemploMob(!showSubMenuExemploMob);
   
    }

    
    const value = {
        showSubMenuProduct, handleShowSubMenuProduct,
        showSubMenuProductMob, handleShowSubMenuProductMob,


        showSubMenuSolutions, handleShowSubMenuSolutions,
        showSubMenuSolutionsMob, handleShowSubMenuSolutionsMob,

        showSubMenuSuporte, handleShowSubMenuSuporte,
        showSubMenuSuporteMob, handleShowSubMenuSuporteMob,

        showSubMenuExemplo, handleShowSubMenuExemplo,
        showSubMenuExemploMob, handleShowSubMenuExemploMob,
        closeOnScroll

    }
    return (
        <SubMenuContext.Provider value={value}>
            {children}
        </SubMenuContext.Provider>
    )
}